import React from "react";
import LegalLayout from "./LegalLayout";

const CorporateGovernance = () => (
  <LegalLayout
    title="Corporate Governance"
    subtitle="Pawansut Holdings Limited — Integrity and accountability"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      Pawansut Holdings Limited is committed to sound corporate governance
      practices that promote transparency, accountability, and long-term value
      for stakeholders. Our governance framework is aligned with applicable
      laws, RBI guidelines for NBFCs, and principles of ethical conduct.
    </p>

    <section>
      <h2>1. Board of Directors</h2>
      <p>
        The Board is responsible for overall strategy, risk oversight, and
        governance. It comprises a mix of executive and non-executive
        directors, including independent directors where required. The Board
        meets at regular intervals and reviews operational, financial, and
        compliance matters. Directors act in the best interest of the Company
        and its stakeholders.
      </p>
    </section>

    <section>
      <h2>2. Board Committees</h2>
      <p>
        The Board has constituted committees to assist in focused oversight:
      </p>
      <ul>
        <li><strong>Audit Committee:</strong> Oversight of financial reporting, internal controls, and audit</li>
        <li><strong>Risk Management Committee:</strong> Identification and mitigation of key risks</li>
        <li><strong>Nomination and Remuneration Committee:</strong> Director and senior management appointments and compensation</li>
        <li><strong>Other committees:</strong> As may be required by law or RBI from time to time</li>
      </ul>
      <p>
        The composition, mandate, and functioning of these committees are in
        line with regulatory requirements and the Company&apos;s Articles of
        Association.
      </p>
    </section>

    <section>
      <h2>3. Code of Conduct and Ethics</h2>
      <p>
        We have a Code of Conduct applicable to Directors and employees,
        covering integrity, confidentiality, avoidance of conflict of interest,
        and compliance with laws. Breaches are dealt with through appropriate
        disciplinary processes.
      </p>
    </section>

    <section>
      <h2>4. Risk Management</h2>
      <p>
        The Company has a risk management framework to identify, assess,
        monitor, and mitigate operational, credit, market, and compliance
        risks. The Board and senior management regularly review risk reports
        and ensure adequate controls are in place.
      </p>
    </section>

    <section>
      <h2>5. Internal Controls and Audit</h2>
      <p>
        Internal controls are designed to ensure reliability of financial
        reporting, effectiveness of operations, and compliance with laws and
        internal policies. Internal audit independently evaluates the
        adequacy and effectiveness of these controls and reports to the Audit
        Committee.
      </p>
    </section>

    <section>
      <h2>6. Transparency and Disclosure</h2>
      <p>
        We disclose material information to regulators, shareholders, and the
        public as required by law and RBI. Our website and investor relations
        communications provide access to key policies, financial information,
        and governance-related updates where applicable.
      </p>
    </section>

    <section>
      <h2>7. Stakeholder Relations</h2>
      <p>
        We engage with customers, employees, lenders, and investors in a fair
        and transparent manner. Customer interests are addressed through our
        Fair Practice Code, Grievance Redressal Policy, and quality of service.
      </p>
    </section>

    <section>
      <h2>8. Compliance</h2>
      <p>
        Compliance with RBI regulations, Companies Act, and other applicable
        laws is a priority. The Board and management ensure that policies and
        processes are updated to reflect regulatory changes.
      </p>
    </section>

    <section>
      <h2>9. Review</h2>
      <p>
        Our corporate governance practices and related policies are reviewed
        periodically and updated to align with best practices and regulatory
        developments. For detailed information on the Board and committees,
        please refer to our Leadership and Investor Relations sections.
      </p>
    </section>
  </LegalLayout>
);

export default CorporateGovernance;
